import { Agent } from "@/types/app/agent";
import { FileLabelWithPopover } from "@components/library/Entities/FileLabelWithPopover";
import { PageSectionHeader } from "@components/library/PageSectionHeader";
import Tag from "@components/library/v2/Tag";
import { JSONViewer } from "@components/llama/Code/JSONViewer";
import { ToolFunctionWithPopover } from "@components/PromptEditor/Tools/ToolFunctionWithPopover";
import { isEmpty } from "lodash";

export type ToolDetailsProps = Pick<Agent, "tools">; // TODO(v5): Add linked_tools.

export const ToolDetails = ({ tools }: ToolDetailsProps) => {
  if (isEmpty(tools)) {
    return null;
  }

  const linkedTools = tools.filter((tool) => tool.type === "file");
  const inlineTools = tools.filter((tool) => tool.type === "inline");

  return (
    <div className="mt-24">
      <PageSectionHeader title={"Tools"} size="sm" />
      <div className={"flex flex-col gap-12"}>
        {inlineTools?.map((tool, index) => (
          <div key={index} className="flex flex-col gap-8 text-11-16">
            <div className="flex items-center gap-8 text-12-14 font-bold">
              <ToolFunctionWithPopover key={tool.json_schema.name} toolFunction={tool.json_schema} />
              {tool.on_agent_call === "stop" && <Tag shade="gray">Stopping tool</Tag>}
            </div>
            <div className="flex items-center gap-8 text-12-14">
              <div className="w-full rounded border border-oldgray-400 px-8 py-8">
                <JSONViewer
                  rootName={false}
                  value={{
                    name: tool.json_schema.name,
                    description: tool.json_schema.description,
                    parameters: tool.json_schema.parameters,
                  }}
                  defaultInspectDepth={0}
                />
              </div>
            </div>
          </div>
        ))}

        {linkedTools?.map((tool) => (
          <div key={tool.file.id} className="flex items-center gap-8">
            <div>
              <FileLabelWithPopover fileId={tool.file.id} displayFile size={20} versionId={tool.file.version_id} />
            </div>
            {tool.on_agent_call === "stop" && <Tag shade="gray">Stopping tool</Tag>}
          </div>
        ))}
      </div>
    </div>
  );
};
